// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-border[data-v-ee2b9c04] {\n  border: none;\n}", ""]);
// Exports
module.exports = exports;
